<template>
  <div>
    <h2 class="form-title">
      {{ $texts.baseFieldsTitle }}
    </h2>
    <select-field
      v-if="formData.field_Title && formData.field_Title.visible"
      fieldId="Title"
      :name="formData.field_Title.name"
      :description="formData.field_Title.description"
      :tooltip="formData.field_Title.tooltip"
      :required="formData.field_Title.required"
      :enabled="formData.field_Title.enabled"
      :options="titleOptions"
      v-model="registrationData.user.title"
    ></select-field>

    <input-field
      v-if="formData.field_LastName && formData.field_LastName.visible"
      fieldId="LastName"
      :name="formData.field_LastName.name"
      :description="formData.field_LastName.description"
      :tooltip="formData.field_LastName.tooltip"
      :required="formData.field_LastName.required"
      :enabled="formData.field_LastName.enabled"
      :pattern="formData.field_LastName.regexp"
      v-model="registrationData.user.lastName"
    ></input-field>

    <input-field
      v-if="formData.field_FirstName && formData.field_FirstName.visible"
      fieldId="FirstName"
      :name="formData.field_FirstName.name"
      :description="formData.field_FirstName.description"
      :tooltip="formData.field_FirstName.tooltip"
      :required="formData.field_FirstName.required"
      :enabled="formData.field_FirstName.enabled"
      :pattern="formData.field_FirstName.regexp"
      v-model="registrationData.user.firstName"
    ></input-field>

    <!-- Profession et spécialité -->
    <profession-speciality
      v-if="
        formData.field_ProfessionSpecialite &&
          formData.field_ProfessionSpecialite.visible
      "
      fieldId="Field"
      :name="formData.field_ProfessionSpecialite.name"
      :description="formData.field_ProfessionSpecialite.description"
      :tooltip="formData.field_ProfessionSpecialite.tooltip"
      :required="formData.field_ProfessionSpecialite.required"
      :enabled="formData.field_ProfessionSpecialite.enabled"
      :professionId.sync="registrationData.user.idProfession"
      :specialityId.sync="registrationData.user.idSpeciality"
    ></profession-speciality>

    <input-field
      v-if="formData.field_Mail && formData.field_Mail.visible"
      fieldId="Mail"
      :name="formData.field_Mail.name"
      :description="formData.field_Mail.description"
      :tooltip="formData.field_Mail.tooltip"
      :required="formData.field_Mail.required"
      :enabled="formData.field_Mail.enabled"
      :pattern="formData.field_Mail.regexp"
      v-model="registrationData.user.email"
      type="email"
    ></input-field>
    <input-field
      v-if="formData.field_ConfirmMail && formData.field_ConfirmMail.visible"
      fieldId="ConfirmMail"
      :name="formData.field_ConfirmMail.name"
      :description="formData.field_ConfirmMail.description"
      :tooltip="formData.field_ConfirmMail.tooltip"
      :required="formData.field_ConfirmMail.required"
      :enabled="formData.field_ConfirmMail.enabled"
      :pattern="formData.field_ConfirmMail.regexp"
      v-model="registrationData.user.confirmMail"
      type="email"
      :customRules="{ confirmed: 'Mail' }"
    ></input-field>
    <input-field
      v-if="formData.field_NationalId && formData.field_NationalId.visible"
      fieldId="NationalId"
      :name="formData.field_NationalId.name"
      :description="formData.field_NationalId.description"
      :tooltip="formData.field_NationalId.tooltip"
      :required="formData.field_NationalId.required"
      :enabled="formData.field_NationalId.enabled"
      :pattern="formData.field_NationalId.regexp"
      v-model="registrationData.user.nationalId"
    ></input-field>
    <input-field
      v-if="formData.field_Phone && formData.field_Phone.visible"
      fieldId="Phone"
      :name="formData.field_Phone.name"
      :description="formData.field_Phone.description"
      :tooltip="formData.field_Phone.tooltip"
      :required="formData.field_Phone.required"
      :enabled="formData.field_Phone.enabled"
      :pattern="formData.field_Phone.regexp"
      v-model="registrationData.user.phone"
      type="phone"
    ></input-field>
    <input-field
      v-if="formData.field_MobilePhone && formData.field_MobilePhone.visible"
      fieldId="MobilePhone"
      :name="formData.field_MobilePhone.name"
      :description="formData.field_MobilePhone.description"
      :tooltip="formData.field_MobilePhone.tooltip"
      :required="formData.field_MobilePhone.required"
      :enabled="formData.field_MobilePhone.enabled"
      :pattern="formData.field_MobilePhone.regexp"
      v-model="registrationData.user.mobilePhone"
      type="phone"
    ></input-field>
    <text-area-field
      v-if="formData.field_Comment && formData.field_Comment.visible"
      fieldId="Comment"
      :name="formData.field_Comment.name"
      :description="formData.field_Comment.description"
      :tooltip="formData.field_Comment.tooltip"
      :required="formData.field_Comment.required"
      :enabled="formData.field_Comment.enabled"
      :pattern="formData.field_Comment.regexp"
      v-model="registrationData.user.comment"
    ></text-area-field>

    <h2 class="form-title" v-if="ShowIdentifiantAndMp()">
      {{ $texts.formIdentifierWithPasswordTitle }}
    </h2>
    <!-- Tous les champs d'identification -->
    <identifier-fields
      :formData="formData"
      :userData="registrationData.user"
      :isAuthentified="isAuthentified()"
    ></identifier-fields>
  </div>
</template>

<script>
import SelectField from "./fields/SelectField.vue";
import InputField from "./fields/InputField.vue";
import TextAreaField from "./fields/TextAreaField.vue";
import ProfessionSpeciality from "./fields/ProfessionSpeciality.vue";
import IdentifierFields from "./fields/IdentifierFields.vue";
import { AccountLoginGenerationService } from "../services/AccountLoginGenerationService";
import { SharedService } from "../../Commons/services/SharedService";

import Vue from "vue";
import { RegistrationSubMode } from "../models/enums/RegistrationSubMode";

export default Vue.extend({
  name: "form-base-fields",

  components: {
    SelectField,
    InputField,
    TextAreaField,
    ProfessionSpeciality,
    IdentifierFields
  },

  props: {
    formData: {
      type: Object,
      required: true
    },
    registrationData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      titles: [],
      // avoid to spam the webservice each key was pressed
      accountLoginGenerationTimeoutId: 0
    };
  },

  computed: {
    additionalFields() {
      return this.formData.additionalFields
        .filter(f => f.visible)
        .sort((a, b) => a.order - b.order);
    },
    attachmentFields() {
      return this.formData.attachmentFields
        .filter(f => f.visible)
        .sort((a, b) => a.order - b.order);
    },
    titleOptions() {
      return this.titles.map(t => ({ value: t.short, label: t.short }));
    }
  },

  methods: {
    async getTitles() {
      this.titles = await SharedService.getTitles();
    },
    async refreshLogin() {
      if (!this.isAuthentified()) {
        let nom = "";
        let prenom = "";
        if (this.registrationData.user.lastName !== null) {
          nom = this.removeSpaces(this.registrationData.user.lastName);
        }
        if (this.firstName !== null) {
          prenom = this.removeSpaces(this.registrationData.user.firstName);
        }

        // login generation from webservice if enabled
        if (this.$appSettings.LoginGenerationEnabled) {
          if (nom && prenom) {
            if (this.accountLoginGenerationTimeoutId) {
              clearTimeout(this.accountLoginGenerationTimeoutId);
            }

            this.accountLoginGenerationTimeoutId = setTimeout(async () => {
              this.registrationData.user.login = await AccountLoginGenerationService.GenerateLogin(
                prenom,
                nom
              );
              this.accountLoginGenerationTimeoutId = 0;
            }, 350);
          } else {
            // either the first or last name was not written, or one of the two was there and the user deleted them
            this.registrationData.user.login = "";
          }
        } else {
          this.registrationData.user.login = `${prenom.toLowerCase()}${nom.toLowerCase()}`;
        }
      }
    },

    removeSpaces(chaine) {
      return chaine.trim();
    },

    isAuthentified() {
      return (
        this.registrationData.registrationSubMode ==
          RegistrationSubMode.Update ||
        this.registrationData.registrationSubMode ==
          RegistrationSubMode.CGUValidation
      );
    },

    ShowIdentifiantAndMp() {
      if (
        (this.formData.field_Login != null &&
          this.formData.field_Login.visible) ||
        (this.formData.field_Password != null &&
          this.formData.field_Password.visible &&
          !this.isAuthentified())
      ) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getTitles();
    this.refreshLogin();
  },

  watch: {
    "registrationData.user.firstName": {
      handler() {
        this.refreshLogin();
      }
    },
    "registrationData.user.lastName": {
      handler() {
        this.refreshLogin();
      }
    }
  }
});
</script>

<style scoped>
.form-title {
  font-size: 25px;
  color: #2fa1ba;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
